import { render } from "./IconClipboard.vue?vue&type=template&id=33fb5cc9&ts=true"
import script from "./IconClipboard.vue?vue&type=script&lang=ts"
export * from "./IconClipboard.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__